// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 563) return "static/chunks/563-f01327fdecfde41a.js";
	if (chunkId === 6979) return "static/chunks/6979-5e418d3bcdc344fd.js";
	if (chunkId === 6589) return "static/chunks/6589-3c102e1e56de9dce.js";
	if (chunkId === 7942) return "static/chunks/7942-abc9bbdd829d1468.js";
	if (chunkId === 1868) return "static/chunks/1868-fb0116753b31dfee.js";
	if (chunkId === 10) return "static/chunks/10-03cd0152e52fd1d1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"d7201dccfa2b3ca4","754":"a592c1210446eb46","1053":"8061ce15e94b5086","1822":"5749dd6414f38865","1853":"9000c64b3df4a163","2661":"638aafbd29e6ef33","4980":"675760feec14dfdb","6182":"4c91381a0fbf945c","8406":"0b704a9800d25b9a","8968":"d6621e3ccb39104c","9760":"685735a3ed538b75"}[chunkId] + ".js";
};